// extracted by mini-css-extract-plugin
export var box = "_45-2";
export var checkboxControl = "_45-0";
export var checkboxRow = "_45-9";
export var checked = "_45-3";
export var descriptionSpacer = "_45-b";
export var disabled = "_45-4";
export var icon = "_45-7";
export var input = "_45-1";
export var labelSpacer = "_45-a";
export var medium = "_45-6";
export var small = "_45-5";
export var text = "_45-8";